module.exports = __webpack_public_path__ + "static/media/screenshot1.35218375.png";